<div>
  <h4 translate>DEBUG_TROUBLESHOOT</h4>
</div>
<hr />
<lib-gung-troubleshooting-product-view></lib-gung-troubleshooting-product-view>
